import { faCog, faPencilAlt } from '@fortawesome/pro-light-svg-icons'

import { CampaignQuoteTemplateModel } from '@models/campaignQuoteTemplate'

import { generateUrls } from '@hooks/useCampaignQuoteTemplate'

const generateTabBarItems = (campaignQuoteTemplate: CampaignQuoteTemplateModel) => {
  const urls = generateUrls(campaignQuoteTemplate, {
    prefixRoute: `agencies/${campaignQuoteTemplate.agency_id}/manage`,
  })

  const { editCampaignQuoteTemplateUrl, editCampaignQuoteTemplateSettingsUrl } = urls

  return [
    {
      icon: faPencilAlt,
      href: editCampaignQuoteTemplateUrl,
      key: 'editor',
      title: 'Editor',
    },
    {
      icon: faCog,
      href: editCampaignQuoteTemplateSettingsUrl,
      key: 'settings',
      title: 'Settings',
    },
  ]
}

export default generateTabBarItems
